import { SettingSettingData } from "../../types";

import { useTypedSelector } from ".";

export const useSettingSetting = (): SettingSettingData | null =>
  useTypedSelector(state => state.setting.setting);
